import type { ComponentProps, PropsWithChildren } from 'react';
import { Modal } from 'is24-corecss';
import { styles } from './styles';
import { useSlots } from './SlotContext';

export const Footer = ({
  className = '',
  children,
  ...props
}: PropsWithChildren<Omit<ComponentProps<typeof Modal.Footer>, 'id' | 'children'>>) => {
  const { footerId } = useSlots();
  return (
    <Modal.Footer {...props} id={footerId} className={`${styles.fixedSection} ${className}`}>
      {children}
    </Modal.Footer>
  );
};
